module.exports = __webpack_public_path__ + "img/animal_dog_osuwari.352ee897.png";